// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"126":"5ee04b6559668dda","581":"a39d7fdfe344a1f9"}[chunkId] + ".css";
};